import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { UserData } from 'utils';

type ReturnType = Promise<AxiosResponse<UserData>>;

const updateUserWhoRegisteredByPhone = (
    userUuid: string,
    user_name: string,
    email: string,
    password: string,
): ReturnType => {
    const payload = {
        email,
        user_name,
        password,
        password_confirmation: password,
    };

    return Request.put(`/users/${userUuid}/update-phone-user`, payload);
};

export default updateUserWhoRegisteredByPhone;
